
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { StatusItemProps } from ".";
import { loading, index, options } from "store/status";

interface ApiStatusInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiStatusOutputProps = OutputBaseProps<{ list: StatusItemProps[]; pagination?: PaginationProps; }>

export const apiStatusIndex = async (data: ApiStatusInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStatusOutputProps>("/api/statuses", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiStatusOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiStatusOutputProps>("/api/statuses", { params: { ...data, fields: "id,code,name,sort" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};